/**
 * Whether a run's group carries a task count at all. A run that opened no task is not an empty run —
 * it still fired — so its head is the bare date and its body says so, rather than "0 tasks created".
 * Shared 1:1 with iOS `RoutineRunBody` and Android `routineRunHeader`.
 */
export function showsTaskCount(taskCount: number): boolean {
  return taskCount > 0;
}
